import { useCallback } from 'react';
import useSnackbarStore, { SnackbarOptions } from 'src/store/snackbar';

export const useSnackbar = () => {
  const showSnackbar = useSnackbarStore.use.showSnackbar();

  const showSuccessAlert = useCallback(
    (message: string, options?: Omit<SnackbarOptions, 'severity'>) => {
      showSnackbar(message, { ...options, severity: 'success' });
    },
    [showSnackbar],
  );

  const showErrorAlert = useCallback(
    (message: string, options?: Omit<SnackbarOptions, 'severity'>) => {
      showSnackbar(message, { ...options, severity: 'error' });
    },
    [showSnackbar],
  );

  const showInfoAlert = useCallback(
    (message: string, options?: Omit<SnackbarOptions, 'severity'>) => {
      showSnackbar(message, { ...options, severity: 'info' });
    },
    [showSnackbar],
  );

  return { showSuccessAlert, showErrorAlert, showInfoAlert };
};
